module.exports = __webpack_public_path__ + "img/14.c8a097cf.png";